import * as Yup from 'yup'

/* Validação do cadastro de médico, compartilhada entre criar e editar — a
   diferença entre as duas telas é só a senha, exigida na criação.

   Sobre o CRM: não existe validação contra o CFM. O Conselho tem o webservice
   de listagem, mas exige chave contratada pelo representante legal da empresa;
   enquanto isso não existe, o que dá para garantir daqui é formato e
   coerência. A unicidade do par CRM+UF é checada no servidor, que é quem
   enxerga a base inteira. */

const somenteNumeros = /^[0-9]*$/

const camposDeCRM = {
  crm: Yup.string().matches(somenteNumeros, 'Somente números'),
  crm_uf: Yup.string().when('crm', {
    is: valor => !!valor,
    then: Yup.string().required('Informe a UF do CRM')
  }),
  crm_secondary: Yup.string()
    .matches(somenteNumeros, 'Somente números')
    .test('diferente-do-principal', 'Repete o CRM principal', function (valor) {
      if (!valor) return true
      return !(valor === this.parent.crm && this.parent.crm_secondary_uf === this.parent.crm_uf)
    }),
  crm_secondary_uf: Yup.string().when('crm_secondary', {
    is: valor => !!valor,
    then: Yup.string().required('Informe a UF do CRM secundário')
  })
}

export const schemaDeCriacao = Yup.object().shape({
  name: Yup.string().required(),
  login: Yup.string().email().required(),
  password: Yup.string().min(6).required(),
  ...camposDeCRM
})

export default Yup.object().shape({
  name: Yup.string().required(),
  ...camposDeCRM
})
